import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { Stop } from './stop.model';
import { StopState, StopStore } from './stop.store';

@Injectable({ providedIn: 'root' })
export class StopQuery extends QueryEntity<StopState> {
  constructor() {
    super(inject(StopStore));
  }

  /** Present (non-exited) stops — the organizer list, mirroring the old attendant "present" view. */
  selectPresent(): Observable<Stop[]> {
    return this.selectAll({ filterBy: (s) => !s.exited });
  }
}
